import { Grid, Box, Typography, TextField, Button } from "@material-ui/core";
import { WHITE, GREEN_PRIMRY, BLUE_PRIMARY, ERROR_COLOR } from "../utils/const";
import { Autocomplete } from "@material-ui/lab";
import { useHistory } from "react-router";
import useCustomState from "../hooks/State";
import Call from "../service/API";
import SuccessModal from "../components/generalModals/SuccessModal";

const AddAdmin = (props) => {
  const levels = [
    { title: "مدیر پروژه", id: "Middle" },
    { title: "مدیر کل", id: "Base" },
  ];

  const successModalOpen = useCustomState(false);
  const successTitle = useCustomState("");
  const successMessage = useCustomState("کاربر با موفقیت افزوده شد.");

  const openSuccessModal = () => {
    successModalOpen.handleChange(true);
  };

  const name = useCustomState("");
  const lastname = useCustomState("");
  const phoneNumber = useCustomState("");
  const password = useCustomState("");
  const selectedLevel = useCustomState(levels[0]);
  const description = useCustomState("");

  const nameError = useCustomState({ error: false, text: "" });
  const lastnameError = useCustomState({ error: false, text: "" });
  const phoneNumberError = useCustomState({ error: false, text: "" });
  const passwordError = useCustomState({ error: false, text: "" });
  const selectedLevelError = useCustomState({ error: false, text: "" });

  const nameChanged = (e) => {
    nameError.handleChange({ error: false, text: "" });
    name.handleChange(e.target.value);
  };

  const lastnameChanged = (e) => {
    lastnameError.handleChange({ error: false, text: "" });
    lastname.handleChange(e.target.value);
  };

  const phoneNumberChanged = (e) => {
    phoneNumberError.handleChange({ error: false, text: "" });
    phoneNumber.handleChange(e.target.value);
  };

  const passwordChanged = (e) => {
    passwordError.handleChange({ error: false, text: "" });
    password.handleChange(e.target.value);
  };

  const levelChanged = (e, newValue) => {
    selectedLevelError.handleChange({ error: false, text: "" });
    selectedLevel.handleChange(newValue);
  };

  const descriptionChanged = (e) => {
    description.handleChange(e.target.value);
  };

  const history = useHistory();

  const goToAdminList = () => {
    history.push("/admin/accessability");
  };

  const addAdmin = () => {
    let hasError = false;
    if (name.value.length === 0) {
      nameError.handleChange({
        error: true,
        text: "واردکرد نام مدیر الزامی است.",
      });
      hasError = true;
    }
    if (lastname.value.length === 0) {
      lastnameError.handleChange({
        error: true,
        text: "واردکردن نام خانوادگی مدیر الزامی است.",
      });
      hasError = true;
    }
    if (phoneNumber.value.length === 0) {
      phoneNumberError.handleChange({
        error: true,
        text: "واردکردن شماره تلفن الزامی است.",
      });
      hasError = true;
    }
    if (password.value.length === 0) {
      passwordError.handleChange({
        error: true,
        text: "واردکردن رمز عبور الزامی است.",
      });
      hasError = true;
    }
    if (selectedLevel.value === null) {
      selectedLevelError.handleChange({
        error: true,
        text: "انتخاب سطح دسترسی الزامی است.",
      });
      hasError = true;
    }
    if (password.value.length < 4) {
      passwordError.handleChange({
        error: true,
        text: "طول رمز عبور انتخاب شده حداقل باید 4 کاراکتر باشد.",
      });
      hasError = true;
    }
    if (hasError) {
      return;
    }

    const permissions = [
      "User",
      "Category",
      "Notice",
      "WaterMeterProject",
      "WaterMeterType",
      "Consumption",
      "Admin",
      "WaterMeterModule",
      "Self",
    ];
    permissions.push(selectedLevel.value.id);

    const jsonData = {
      admin_name: name.value,
      admin_lastname: lastname.value,
      admin_phone: phoneNumber.value,
      admin_password: password.value,
      other_information: {
        description: description.value,
      },
      admin_permissions: permissions,
    };

    const data = new FormData();
    data.append("data", JSON.stringify(jsonData));

    Call("POST", "admins/admin/add", data)
      .then((response) => {
        if (response.data.code === 200) {
          openSuccessModal();
          name.handleChange("");
          lastname.handleChange("");
          phoneNumber.handleChange("");
          password.handleChange("");
          selectedLevel.handleChange(levels[0]);
          description.handleChange("");
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
        }
      });
  };

  const renderName = () => {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        style={{
          paddingRight: "5%",
          paddingLeft: "5%",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <TextField
          error={nameError.value.error}
          helperText={nameError.value.text}
          onChange={nameChanged}
          value={name.value}
          fullWidth
          variant="standard"
          label="نام"
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          size="small"
        ></TextField>
      </Grid>
    );
  };

  const renderLastname = () => {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        style={{
          paddingRight: "5%",
          paddingLeft: "5%",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <TextField
          error={lastnameError.value.error}
          helperText={lastnameError.value.text}
          onChange={lastnameChanged}
          value={lastname.value}
          fullWidth
          variant="standard"
          label="نام خانوادگی"
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          size="small"
        ></TextField>
      </Grid>
    );
  };

  const renderPhoneNumber = () => {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        style={{
          paddingRight: "5%",
          paddingLeft: "5%",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <TextField
          error={phoneNumberError.value.error}
          helperText={phoneNumberError.value.text}
          onChange={phoneNumberChanged}
          value={phoneNumber.value}
          fullWidth
          variant="standard"
          label="شماره تلفن"
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          size="small"
        ></TextField>
      </Grid>
    );
  };

  const renderPassword = () => {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        style={{
          paddingRight: "5%",
          paddingLeft: "5%",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <TextField
          error={passwordError.value.error}
          helperText={passwordError.value.text}
          onChange={passwordChanged}
          value={password.value}
          fullWidth
          variant="standard"
          label="رمز عبور"
          type={"password"}
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          size="small"
        ></TextField>
      </Grid>
    );
  };

  const renderLevel = () => {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        style={{
          paddingRight: "5%",
          paddingLeft: "5%",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <Autocomplete
          onChange={levelChanged}
          value={selectedLevel.value}
          options={levels}
          getOptionLabel={(option) => option.title}
          renderInput={(params) => (
            <TextField
              error={selectedLevelError.value.error}
              helperText={selectedLevelError.value.text}
              {...params}
              label="سطح دسترسی"
              variant="standard"
            />
          )}
        />
      </Grid>
    );
  };

  const renderDescription = () => {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          paddingRight: "5%",
          paddingLeft: "5%",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <TextField
          onChange={descriptionChanged}
          value={description.value}
          fullWidth
          variant="filled"
          label="توضیحات"
          multiline
          rows={8}
          maxRows={12}
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          size="small"
        ></TextField>
      </Grid>
    );
  };

  const renderButtons = () => {
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          paddingRight: "5%",
          paddingLeft: "5%",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <Button
          onClick={addAdmin}
          style={{
            backgroundColor: BLUE_PRIMARY,
            marginLeft: "12px",
            color: WHITE,
          }}
        >
          افزودن
        </Button>
        <Button
          onClick={goToAdminList}
          style={{ backgroundColor: ERROR_COLOR, color: WHITE }}
        >
          بازگشت
        </Button>
      </Grid>
    );
  };

  const renderForm = () => {
    return (
      <>
        {renderName()}
        {renderLastname()}
        {renderPhoneNumber()}
        {renderPassword()}
        {renderLevel()}
        {renderDescription()}
        {renderButtons()}
      </>
    );
  };

  return (
    <>
      <SuccessModal
        open={successModalOpen}
        title={successTitle.value}
        message={successMessage.value}
        style={{ successColor: GREEN_PRIMRY }}
      />
      <Grid
        container
        style={{
          marginTop: "64px",
          paddingTop: "16px",
          paddingBottom: "16px",
          paddingRight: "8px",
          paddingLeft: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            backgroundColor: WHITE,
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <Box
            style={{
              maxWidth: "250px",
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: "-60px",
              paddingRight: "36px",
              paddingLeft: "36px",
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRadius: "12px",
              backgroundColor: GREEN_PRIMRY,
              color: WHITE,
              cursor: "pointer",
            }}
            textAlign={"center"}
          >
            <Typography style={{ fontWeight: "bold" }}>
              افزودن مدیر جدید
            </Typography>
          </Box>
          <Grid container style={{ paddingTop: "48px", paddingBottom: "48px" }}>
            {/* {renderAdminList()}
              {renderAddAdminBtn()} */}
            {renderForm()}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AddAdmin;
